import { Injectable } from "@angular/core";

@Injectable()
export class NavigationService {
    loading= false;
}